import { useChannels } from '~publish/components/MainSidebar/components/ChannelsSection/useChannels'
import { areAllChannelsViewOnlyForPublish } from '~publish/utils/permissions/viewOnlyPublish'

/**
 * Whether the current actor is view-only across Publish: they can open at
 * least one channel but cannot create posts or drafts on any of them.
 *
 * `false` while channels are loading and for members with no viewable
 * channels — those states have their own treatments, so only a confirmed
 * view-only set should hide create-adjacent surfaces.
 */
export const useIsViewOnlyPublishUser = (): boolean => {
  const { channels } = useChannels()
  return areAllChannelsViewOnlyForPublish(channels)
}
